"use client";
import { useTranslations } from "next-intl";
import { Link, useRouter } from "@/navigation";
import Image from "next/image";

// 移动端组件
const MobileView = ({ data }: { data: Array<any> }) => {
	const t = useTranslations();
	return (
		<div className="relative w-full md:hidden" role="region" aria-label="Product advantages mobile view">
			<Image
				src="/image/why2.webp"
				alt="Product advantages background"
				width={750}
				height={1334}
				className="h-full w-full object-cover"
			/>
			<h2 className="font-queens absolute left-0 right-0 top-8 mb-4 flex-nowrap text-center text-[28px] font-medium  md:text-[42px] lg:text-[52px]">
				{/* {t("home.whyb")} */}
				{/* <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-black transition-all duration-300 group-hover:w-full"></span> */}
			</h2>
			<div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 pb-16">
				<ul className="grid grid-cols-2 gap-8 max-md:mb-8">
					{data.map((item) => (
						<li key={item.id} className="flex flex-col items-center text-center">
							<h3 className="text-[20px] font-bold text-main">{item.title}</h3>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

// 桌面端组件
const DesktopView = ({
	leftColumnData,
	rightColumnData,
}: {
	leftColumnData: Array<any>;
	rightColumnData: Array<any>;
}) => {
	const t = useTranslations();
	return (
		<div
			className="relative hidden w-full md:block"
			role="region"
			aria-label="Product advantages desktop view"
		>
			<Image
				src="/image/why.webp"
				alt="Product advantages background"
				width={1920}
				height={870}
				className="h-full w-full object-cover"
			/>
			{/* <h2 className="absolute left-0 right-0 top-8 mb-4 flex-nowrap text-center font-queens text-[28px] font-medium  md:text-[42px] lg:text-[52px]">
				{t("home.whyb")}
				<span className="absolute bottom-0 left-0 h-0.5 w-0 bg-black transition-all duration-300 group-hover:w-full"></span>
			</h2> */}
			<div className="absolute inset-0 flex justify-between p-4 md:p-6 lg:p-8">
				{/* 左列 */}
				<div className="flex w-1/2 flex-col justify-between pr-2 md:pr-[240px] lg:py-[120px]">
					<ul className="flex h-full flex-col justify-between">
						{leftColumnData.map((item) => (
							<li key={item.id} className="flex flex-col items-center gap-1 text-center md:gap-2">
								<h3 className="text-[16px] font-bold text-main md:text-[20px] lg:text-[24px]">
									{item.title}
								</h3>
								<p className="max-w-[250px] text-[12px] text-white max-xl:hidden md:max-w-[220px] md:text-[14px] lg:max-w-[330px] lg:text-[16px]">
									{item.description}
								</p>
							</li>
						))}
					</ul>
				</div>

				{/* 右列 */}
				<div className="flex w-1/2 flex-col justify-between pl-2 md:pl-[240px] lg:py-[120px]">
					<ul className="flex h-full flex-col justify-between">
						{rightColumnData.map((item) => (
							<li key={item.id} className="flex flex-col items-center gap-1 text-center md:gap-2">
								<h3 className="text-[16px] font-bold text-main md:text-[20px] lg:text-[24px]">
									{item.title}
								</h3>
								<p className="max-w-[200px] text-[12px] text-white max-xl:hidden md:max-w-[220px] md:text-[14px] lg:max-w-[330px] lg:text-[16px]">
									{item.description}
								</p>
							</li>
						))}
					</ul>
				</div>
			</div>
		</div>
	);
};

export default function WhyChooseUs() {
	const t = useTranslations();

	const leftColumnData = [
		{
			id: 1,
			icon: "🔋",
			title: t("home.wt1"),
			description: t("home.wdes1"),
		},
		{
			id: 2,
			icon: "☀️",
			title: t("home.wt2"),
			description: t("home.wdes2"),
		},
		{
			id: 3,
			icon: "🔌",
			title: t("home.wt3"),
			description: t("home.wdes3"),
		},
	];

	const rightColumnData = [
		{
			id: 4,
			icon: "⚡",
			title: t("home.wt4"),
			description: t("home.wdes4"),
		},
		{
			id: 5,
			icon: "✔️",
			title: t("home.wt5"),
			description: t("home.wdes5"),
		},
		{
			id: 6,
			icon: "💡",
			title: t("home.wt6"),
			description: t("home.wdes6"),
		},
	];

	// 合并数据用于移动端显示
	const allData = [...leftColumnData, ...rightColumnData];

	return (
		<section className="py-8 md:pb-0" aria-labelledby="why-choose-us-title">
			<div className="h-[1px] w-full bg-black" aria-hidden="true"></div>
			<div className="">
				<div className="flex flex-col items-center gap-4 md:gap-8">
					<h2
						id="why-choose-us-title"
						className="font-queens group relative mb-4 pt-8 text-center text-[28px] font-medium md:text-[42px] lg:text-[52px]"
					>
						{t("home.whyb")}
						<span className="absolute bottom-0 left-0 h-0.5 w-0 bg-black transition-all duration-300 group-hover:w-full"></span>
					</h2>
					<MobileView data={allData} />
					<DesktopView leftColumnData={leftColumnData} rightColumnData={rightColumnData} />
				</div>
			</div>
		</section>
	);
}
